import React, { useState } from 'react';

import { Grid, makeStyles, View, Stack } from '@gogame/components';

import PlayersInformationActions from './PlayersInformationActions';
import Results from './components/Results';
import { useLoadPlayersInformation } from './data';

const useStyles = makeStyles((theme) => ({
  sidebar: {
    height: '100%',
    width: '340px',
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  content: {
    padding: '16px 0 16px 16px',
  },
  root: {
    flexGrow: 1,
    flexWrap: 'nowrap',
  },
}));

const PlayersInformation = () => {
  const classes = useStyles();
  const [params, setParams] = useState();
  const { data, isLoading, isRefetching } = useLoadPlayersInformation(params, {
    enabled: !!params,
  });

  const handleSubmit = (values) => {
    setParams(values);
  };

  return (
    <Grid container className={classes.root}>
      <Grid item>
        <Stack className={classes.sidebar}>
          <PlayersInformationActions
            onSubmit={handleSubmit}
            isLoading={isLoading || isRefetching}
          />
        </Stack>
      </Grid>
      <Grid item container>
        <View
          loading={isLoading}
          fetching={isRefetching}
          className={classes.content}
        >
          <Results data={data} isLoading={isLoading || isRefetching} isEmpty={data === ''} />
        </View>
      </Grid>
    </Grid>
  );
};

export default PlayersInformation;
